module.exports = __webpack_public_path__ + "static/media/thumbnail.1bc20d8d.jpg";